import $ from 'jquery';

export default class SectorListing {
    constructor() {
        if ($('.js-sector-listing').length) {
            $('.js-sector-listing__item').on('click', function() {
                const $this = $(this);
                const sector = $this.data('sector');

                // Reset
                $('.js-sector-listing__item').removeClass('is-active');
                $('.js-sector-listing__highlight').removeClass('is-active');

                $this.addClass('is-active');

                $('.js-sector-listing__highlight').each(function() {
                    const $this = $(this);

                    if($this.data('sector') == sector) {
                        $this.addClass('is-active');
                    };
                });
            });
        };
    };
};
